// extracted by mini-css-extract-plugin
export var root = "fc-media-copy-blocks-module--root--a524a";